export default "__VITE_ASSET__d9b4ea9e__"